import { PROVINCE_VALID_POSTAL_FIRST_CHARS } from '../definitions/Provinces';

// Supports upper & lower case, and an optional space in the middle
const POSTAL_CODE_REGEX = /^[A-Za-z]\d[A-Za-z][ ]?\d[A-Za-z]\d$/;

/**
 * Determine if a postal code is valid for a specific province
 * @param {string} value
 * @param postalCode
 * @param {string} province
 * @returns {bool}
 */
export function postalCodeValidForProvince(postalCode, province) {
    if (!postalCode || !province) {
        return false;
    }

    return !!PROVINCE_VALID_POSTAL_FIRST_CHARS[province]?.includes(postalCode[0].toUpperCase());
}

/**
 * Determine if a string is a valid postal code
 * @param {string} value
 * @returns {bool}
 */
export default function postalCodeValidator(value) {
    return POSTAL_CODE_REGEX.test(value);
}
